import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { storeCouponServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCouponServices";

const UpdateCoupon = ({
  show,
  hide,
  title,
  storeCouponData,
  getStoreCouponList,
  setStoreCouponData,
  setStoreCouponIds,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedStoreCoupon = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this Store Coupon?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.couponId = storeCouponData?.couponId
        userData.name = name
        userData.description = description
        userData.settings = "update"
        let data = await storeCouponServices.updatedStoreCoupon(userData)
        if (data?.statusCode === 200) {
          clearData();
          getStoreCouponList()
          setStoreCouponIds([])
          setStoreCouponData("")
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setName("");
    setDescription("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (show && storeCouponData) {
      setName(storeCouponData?.name);
      setDescription(storeCouponData?.description);
      setLoader(false)
    }
  }, [show, storeCouponData]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Description <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              as={`textarea`}
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter Description"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button
              onClick={updatedStoreCoupon}
              disabled={!name || !description || loader}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateCoupon;
